<template>
  <div
    class="BoxDoc mb-4">
    <div class="BoxDoc_header p-2">
      <h3 class="BoxDoc_header_title">
        {{ getDocumentLabel(documento.tipo_documento) }}
      </h3>
    </div>

    <div class="BoxDoc_body px-3 py-2">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="d-inline-flex BoxDoc_body_content">
          <div class="d-inline-block mr-5">
            <ul class="BoxDoc_list">
              <li class="BoxDoc_list_item BoxDoc_list_title">
                Número
              </li>

              <li class="BoxDoc_list_item">
                <strong>{{ documento.numero }}</strong>
              </li>
            </ul>
          </div>

          <div v-if="documento.serie"
               class="d-inline-block mr-5">
            <ul class="BoxDoc_list">
              <li class="BoxDoc_list_item BoxDoc_list_title">
                Série
              </li>

              <li class="BoxDoc_list_item">
                <strong>{{ documento.serie }}</strong>
              </li>
            </ul>
          </div>

          <div v-if="documento.codigo_orgao_emissor"
               class="d-inline-block mr-5">
            <ul class="BoxDoc_list">
              <li class="BoxDoc_list_item BoxDoc_list_title">
                Orgão Emissor
              </li>

              <li class="BoxDoc_list_item">
                <strong>{{ orgao_emissor.descricao }}</strong>
              </li>
            </ul>
          </div>

          <div v-if="documento.uf_emissor"
               class="d-inline-block mr-5">
            <ul class="BoxDoc_list">
              <li class="BoxDoc_list_item BoxDoc_list_title">
                UF Emissor
              </li>

              <li class="BoxDoc_list_item">
                <strong>{{ documento.uf_emissor }}</strong>
              </li>
            </ul>
          </div>

          <div v-if="documento.data_emissao"
               class="d-inline-blo_ck mr-5">
            <ul class="BoxDoc_list">
              <li class="BoxDoc_list_item BoxDoc_list_title">
                {{ documento.tipo_documento == 'CNH' ? 'Data 1ª Habilitação' : 'Data de emissão' }}
              </li>

              <li class="BoxDoc_list_item">
                <strong>{{ dateOfEmission() }}</strong>
              </li>
            </ul>
          </div>

          <div v-if="documento.descricao"
               class="d-inline-block mr-5">
            <ul class="BoxDoc_list">
              <li class="BoxDoc_list_item BoxDoc_list_title">
                Tipo de Documento
              </li>

              <li class="BoxDoc_list_item">
                <strong>{{ documento.descricao }}</strong>
              </li>
            </ul>
          </div>
        </div>

        <div class="">
          <div v-if="!noEditButton"
               class="row no-gutters justify-content-end align-items-center">
            <div class="d-inline-block">
              <button type="button"
                      class="btn btn-sm btn-danger mr-2"
                      @click="$emit('remove', documento)">
                Remover
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getDocumentLabel, getOrgaoEmissor } from "@/constants/documentosPessoais"
  import moment from "moment"

  export default {
    name: 'BoxDocumento',
    props: {
      documento: Object,
      noEditButton: Boolean,
    },
    data () {
      return {
        getDocumentLabel,
        orgaos_emissores: [],
        orgao_emissor: {}
      }
    },
    async mounted () {
      this.orgaos_emissores = await getOrgaoEmissor()
      if (this.documento.codigo_orgao_emissor) {
        this.orgao_emissor = this.orgaos_emissores.find(orgao_emissor => orgao_emissor.codigo == this.documento.codigo_orgao_emissor)
      }
    },
    methods: {
      dateOfEmission () {
        return this.documento.data_emissao ? moment(this.documento.data_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/_exports';

  .BoxDoc {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &_header {
      background-color: #01AEC9;

      color: $color-dark;

      &_title {
        font-size: pxToRem(14);
        font-weight: 500;
      }
    }

    &_body {
      &_content {}
    }

    &_list {
      font-size: pxToRem(14);
      list-style: none;
      margin: 0;
      padding: 0;

      &_item {}

      &_title {
        margin-bottom: pxToRem(4);
        text-decoration: underline;
      }
    }
  }
</style>
